import { GenericObject } from 'vee-validate';

import { QueryParams } from 'lib/components/datatable/DataTable.vue.d';
import eventBus from 'lib/event-bus';
import { getNestedPropertyValue } from 'lib/utils/object.util';

import { formatDateTimeRange } from './formatDateTimeRange.helper';
import { FilterField } from '../FilterContainer.vue.d';

const applyFilter = (
  values: GenericObject,
  tableName: string,
  emit?: (...args: any[]) => any,
): void => {
  const fields = Object.keys(values);
  const parsedFilter: QueryParams = {};

  eventBus.emit('multi-select:hide-overlay');

  fields.forEach((field) => {
    const isArray = Array.isArray(values[field]);
    const isAlreadyString = typeof values[field] === 'string';

    // First, filter out undefined/null values
    const filteredValues: GenericObject = isArray
      ? values[field]?.filter((each: unknown) => each != null)
      : values[field];

    if (
      ((filteredValues != null && !isArray) ||
        (isArray && filteredValues.length)) &&
      !isAlreadyString
    ) {
      // ✅ Detect if values are valid epoch timestamps
      const isEpochTimeArray =
        Array.isArray(filteredValues) &&
        filteredValues.every(
          (num) =>
            typeof num === 'number' &&
            num > 946684800000 && // Greater than 2000-01-01 00:00:00 UTC (milliseconds)
            !isNaN(new Date(num).getTime()), // Converts to a valid date
        );

      if (isEpochTimeArray) {
        parsedFilter[field] = JSON.stringify(
          // Adjust the end range time to 23.59.59 and the start to 00.00.00 to fix filtering issue when user only select a date
          formatDateTimeRange(filteredValues as number[]),
        );
        return;
      }

      // If filtered value still has length then original value will be used
      parsedFilter[field] = filteredValues?.length
        ? JSON.stringify(values[field])
        : JSON.stringify(filteredValues);
    } else {
      parsedFilter[field] = values[field];
    }
  });

  eventBus.emit('data-table:apply-filter', {
    tableName,
    filter: parsedFilter,
  });

  eventBus.emit('data-table:clear-selected-data', {
    tableName,
  });

  emit?.('apply', parsedFilter);
};

export const applyStaticFilter = (
  values: GenericObject,
  tableName: string,
  fields: FilterField[],
  emit?: (...args: any[]) => any,
): void => {
  const nonEmptyFilterValues: GenericObject = {};

  eventBus.emit('multi-select:hide-overlay');

  fields.forEach((field) => {
    if ('field' in field && typeof field.field === 'string') {
      const filterValue = getNestedPropertyValue(values, field.field);
      if (field.field.includes('tags')) {
        console.log('tags', field.field, filterValue, values);
      }
      if ('value' in filterValue && filterValue.value != null) {
        nonEmptyFilterValues[field.field] = filterValue;

        if (
          'matchMode' in filterValue &&
          filterValue.matchMode == 'DATE_BETWEEN'
        ) {
          nonEmptyFilterValues[field.field].value = formatDateTimeRange(
            filterValue.value,
          );
        }

        // Remove the filter meta the value is empty array
        if (
          Array.isArray(filterValue.value) &&
          !filterValue.value.filter(Boolean).length
        ) {
          delete nonEmptyFilterValues[field.field];
        }
      }
    }
  });

  eventBus.emit('data-table:apply-filter', {
    tableName,
    filter: nonEmptyFilterValues,
  });

  eventBus.emit('data-table:clear-selected-data', {
    tableName,
  });

  emit?.('apply', nonEmptyFilterValues);
};

export default applyFilter;
